
import { defineComponent, ref } from 'vue';


import {
  IonContent,
  IonHeader,
  IonPage,
  IonList,
  IonMenu,
  IonRouterOutlet,
  IonTitle,
  IonToolbar,
  IonTextarea,
  IonApp,
  IonIcon,
  IonLabel,
  IonSpinner,
  IonMenuToggle,
  IonFooter,
  IonButton,
  IonButtons,
  IonModal,
  IonGrid,
  IonAvatar,
  IonToggle,
  IonListHeader,
  IonItem,
  IonCol, IonBadge, IonRow,IonInput, alertController } from "@ionic/vue";

import { locationOutline, chevronDown, chevronForward, chevronBack, helpCircle, checkmark, close, search } from 'ionicons/icons';



import fintailapi from "../api";

export default defineComponent({
  name: "tables",
  components: {
    IonContent,
    IonHeader,
    IonPage,
    IonList,
    IonMenu,
    IonRouterOutlet,
    IonTitle,
    IonToolbar,
    IonApp,
    IonToggle,
    IonIcon,
    IonLabel,
    IonSpinner,
    IonTextarea,
    IonMenuToggle,
    IonFooter,
    IonGrid,
    IonAvatar,
    IonListHeader,
    IonButton,
    IonButtons,
    IonModal,
    IonItem,
    IonCol, IonBadge, IonRow,IonInput, alertController

  },
  data() {
    return {
      edit_loja:false,
      produtos: [],
      current_page:0,
      total_pages:0,
      editar() {
        this.edit_loja=true;
      },
    };
  },
  methods: {
    getProdutos(offset:number) {

        fintailapi
        .post('/backend/lojas', { offset : offset, limit : 10})
        .then((response:any) => {

          this.current_page = offset;

          this.produtos = response.data.rows
          this.total_pages = response.data.count / 10

        })
        .catch((error:any) => {

          //this.isOpenRef = true;

        })

      //this.store.state.user.isAuthenticated = true;
       //this.$router.push('/dashboard');
    },
   },
   editar() {

      this.edit_loja=true;


    },
   created() {

      this.getProdutos(0)


    },

});


